import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { ConfidenceStats } from '../ConfidenceStats';
import { useReportContext } from '../../../../../../context/useReportContext';

const TooltipContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  position: 'absolute',
  bottom: 'calc(100% + 16px)',
  background: '#fff',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  border: '1px solid #e3e3e3',
  color: '#1b1b1b',
  whiteSpace: 'initial',
}));

const StyledLevels = styled('ul')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  flexDirection: 'column',
  listStyleType: 'none',
  padding: 0,
  margin: 0,
}));

const LevelHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: 700,
}));

const LevelTitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
}));
const TooltipTitle = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 700,
}));

export const ConfidenceTooltip = () => {
  const { t } = useI18n();
  const { config } = useReportContext();
  const { humanParticipantsAllowed } = config;

  const levels: {
    humanAmount?: string;
    simulationAmount?: string;
    text: I18nResources;
  }[] = humanParticipantsAllowed
    ? [
        {
          humanAmount: '1-4',
          simulationAmount: '1-8',
          text: 'prototypes:report.confidence.level_0_description',
        },
        {
          humanAmount: '5-8',
          simulationAmount: '9-30',
          text: 'prototypes:report.confidence.level_1_description',
        },
        {
          humanAmount: '9-15',
          simulationAmount: '30+',
          text: 'prototypes:report.confidence.level_2_description',
        },
        {
          humanAmount: '15+',
          text: 'prototypes:report.confidence.level_3_description',
        },
      ]
    : [
        {
          simulationAmount: '1-8',
          text: 'prototypes:report.confidence.level_0_description',
        },
        {
          simulationAmount: '9-29',
          text: 'prototypes:report.confidence.level_1_description',
        },
        {
          simulationAmount: '30+',
          text: 'prototypes:report.confidence.level_2_description',
        },
      ];

  return (
    <TooltipContainer>
      <TooltipTitle>
        {t(
          humanParticipantsAllowed
            ? 'prototypes:report.confidence.tooltip_title'
            : 'prototypes:report.confidence.simulation_only_tooltip_title'
        )}
      </TooltipTitle>
      <Typography>
        {t('prototypes:report.confidence.how_many_i_need')}
      </Typography>
      <StyledLevels>
        {levels.map((level, index) => (
          <li key={index}>
            <LevelHeader>
              <LevelTitle>
                {t('prototypes:report.confidence.level', { level: index })}
              </LevelTitle>
              <ConfidenceStats
                human={level.humanAmount}
                simulations={level.simulationAmount}
              />
            </LevelHeader>
            <Typography>{t(level.text)}</Typography>
          </li>
        ))}
      </StyledLevels>
    </TooltipContainer>
  );
};
